import { render, staticRenderFns } from "./Regional.vue?vue&type=template&id=4d72ac33&"
import script from "./Regional.vue?vue&type=script&lang=js&"
export * from "./Regional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports